export const parkingTagTableSelector = ({parkingTagTable}) => parkingTagTable